import React, { useState } from "react";
import { GiCheckMark } from "react-icons/gi";
import { FaPlay, FaPeopleGroup, FaChild, FaPersonDress, FaHouseFloodWater } from "react-icons/fa6";
import { Link } from "react-router-dom";

const Issue: React.FC = () => {
  const IconPlay = FaPlay as React.FC<React.SVGProps<SVGSVGElement>>;
  const IconGrup = FaPeopleGroup as React.FC<React.SVGProps<SVGSVGElement>>;
  const IconChild = FaChild as React.FC<React.SVGProps<SVGSVGElement>>;
  const IconPerson = FaPersonDress as React.FC<React.SVGProps<SVGSVGElement>>;
  const IconHouse = FaHouseFloodWater as React.FC<React.SVGProps<SVGSVGElement>>;
  const [openVideo, setOpenVideo] = useState(false);

  const campaignLink = "https://belaskasih.com/account/campaign/new";

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* ================= LATAR BELAKANG ISU ================= */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-16">
          {/* ===== DESKRIPSI (KANAN) ===== */}
          <div>
            <h1 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4 max-sm:text-center">
              Latar<span className="font-bilbo text-red-600">Belakang Isu</span>
            </h1>

            <p className="text-gray-700 text-base md:text-lg leading-relaxed text-justify">
              <strong>Indonesia</strong> sebagai negara yang kaya akan potensi sumber daya alam, budaya, dan manusia, sejatinya memiliki modal besar untuk mewujudkan kesejahteraan masyarakat. Namun, di balik potensi tersebut, Indonesia
              masih menghadapi permasalahan besar dalam aspek sosial ekonomi, khususnya terkait dengan <span className="font-semibold text-red-600">kemiskinan</span> yang hingga kini belum sepenuhnya teratasi.
            </p>

            <p className="text-gray-700 text-base md:text-lg leading-relaxed mt-4 text-justify">
              Kondisi ini semakin diperparah oleh berbagai faktor struktural, seperti keterbatasan akses terhadap pendidikan, layanan kesehatan, dan peluang ekonomi, ketimpangan pembangunan antarwilayah, serta dampak{" "}
              <span className="font-semibold text-red-600">bencana alam</span> yang kerap terjadi dan memberikan tekanan besar bagi kelompok masyarakat rentan.
            </p>

            {/* ===== BUTTON ISU ===== */}
            {/* <div className="grid grid-cols-2 gap-4 mt-8">
              <Link to={campaignLink} target="_blank" className="flex justify-center items-center gap-3 border border-red-600 text-red-600 px-4 py-3 rounded-xl hover:bg-red-600 hover:text-white transition max-sm:text-base">
                <IconGrup />
                Kemiskinan
              </Link>

              <Link to={campaignLink} target="_blank" className="flex justify-center items-center gap-3 border border-red-600 text-red-600 px-4 py-3 rounded-xl hover:bg-red-600 hover:text-white transition max-sm:text-xs">
                <IconChild />
                Yatim & Dhuafa
              </Link>

              <Link to={campaignLink} target="_blank" className="flex justify-center items-center gap-3 border border-red-600 text-red-600 px-4 py-3 rounded-xl hover:bg-red-600 hover:text-white transition max-sm:text-base">
                <IconPerson />
                Janda
              </Link>

              <Link to={campaignLink} target="_blank" className="flex justify-center items-center gap-3 border border-red-600 text-red-600 px-4 py-3 rounded-xl hover:bg-red-600 hover:text-white transition max-sm:text-base">
                <IconHouse />
                Bencana Alam
              </Link>
            </div> */}
          </div>
          {/* ===== VIDEO (KIRI) ===== */}
          <div className="relative group cursor-pointer" onClick={() => setOpenVideo(true)}>
            <img src="https://img.youtube.com/vi/6y0dLk8-bOw/hqdefault.jpg" alt="Video Isu Sosial" className="rounded-2xl shadow-xl w-full" />

            {/* Overlay */}
            <div className="absolute inset-0 bg-black/40 rounded-2xl flex items-center justify-center">
              <div className="bg-red-600 p-5 rounded-full text-white text-2xl group-hover:scale-110 transition">
                <IconPlay />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================= MODAL VIDEO ================= */}
      {openVideo && (
        <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center px-4">
          <div className="relative w-full max-w-4xl">
            <button className="absolute -top-10 right-0 text-white text-3xl" onClick={() => setOpenVideo(false)}>
              ✕
            </button>

            <div className="aspect-video">
              <iframe src="https://www.youtube.com/embed/6y0dLk8-bOw?autoplay=1" title="YouTube video" allow="autoplay; encrypted-media" allowFullScreen className="w-full h-full rounded-xl" />
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Issue;
